import { Page, Text, View, Document, StyleSheet ,Font ,Image} from '@react-pdf/renderer';
import React from 'react'
import LatoRegular from '../../Assets/Fonts/Lato-Font/Lato-Regular.ttf';
import LatoBold from '../../Assets/Fonts/Lato-Font/Lato-Bold.ttf';
import Header from "./Header";
import Footer from "./Footer";

Font.register({
    family: 'Lato',
    fonts: [
      { src: LatoRegular, fontWeight: 400 },
      { src: LatoBold , fontWeight: 700 }
    ]
});

  const styles = StyleSheet.create({
    pagewapper: {
        position: "relative",
        height: "100%"
    },
    content: {
        // marginTop: "35px",
        display: "flex",
        width: "570px",
        alignItems: "left"
    },
      contenttitle: {
        fontFamily: "Lato",
        fontWeight: 700,
        fontSize: "18px",
        lineHeight: "30px",
        color: "#426B88"
    },
    wapper: {
        width: "567px",
        fontFamily: "Lato",
        fontWeight: 400,
        fontSize: "12px",
        lineHeight: "18px",
        color: "#245775"
      },
      mainContent: {
          flexGrow: 1,
          marginTop:"28px",
    },
    footer: {
        marginTop: 'auto',
    },
    table: {
        width: '100%',
        // borderWidth: 1,
        // borderColor: '#ccc',
    },
    tableRow: {
        flexDirection: 'row',
        paddingVertical: 2,
        alignItems: 'center',
    },
      tableHeader: {
        paddingVertical: 1,
        fontWeight: 400,
        border:'0px',
        backgroundColor: '#245775',
        fontWeight: 'bold',
        color: 'white',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
      },
    headerCell:{color: 'white', fontWeight:400, paddingVertical:"5px"},
    cellQuestion: { width: '70%', fontSize: 10,color:"#394554", fontWeight:400},
    cellScore: { width: '7%', textAlign: 'center', fontSize: 10 },
    cell: {
        padding: "10px",
        textAlign: "left",
      },
      
      rowEven: {
        backgroundColor: "#F1F3F3",
      },
      rowOdd: {
        backgroundColor: "#FFF",
      },
      redRectangle: {
        width: 17,
        height: 17,
          backgroundColor: '#B6111F',
        borderRadius:"1.34px",
    },
      
  });

  const truncateText = (text, limit) => {
    if (text.length <= limit) return text;
    return text.substring(0, text.lastIndexOf(" ", limit)) + "...";
  };

const getLastFilledIndex = (scores) => {
  for (let i = scores.length - 1; i >= 0; i--) {
    if (scores[i] === 1) return i;
  }
  return -1;
};

const renderRectangle = (score, index, scores) => {
  const lastFilledIndex = getLastFilledIndex(scores);
  return index <= lastFilledIndex ? (
    <View style={styles.redRectangle} />
  ) : null;
};

const HeartPage = () => (
  <View style={styles.pagewapper}>
    <Header />
      <View style={styles.content}>
        <Text style={styles.contenttitle}>HEART IN FOCUS</Text>
        <View style={styles.wapper}>
          <Text>This chart isolates the items related to the Heart and ranks them highest to lowest based on the participants self-rating. The response scale runs from 1 (Least) to 4 (Most). Any unselected statement will appear blank in the In Focus section.</Text>
        </View>         
      </View>
      <View style={styles.mainContent}>
        <View style={[styles.tableRow, styles.tableHeader]}>
          <Text style={[styles.cell, styles.cellQuestion, styles.headerCell]}>Heart</Text>
            {[1, 2, 3, 4].map((num) => (
              <Text key={num} style={[styles.cell, styles.cellScore, styles.headerCell]}>
                {num}
              </Text>
            ))}
          </View>

          {data.map((item, index) => (
            <View key={index} style={[styles.tableRow, index % 2 === 0 ? styles.rowEven : styles.rowOdd]}>
              <Text style={[styles.cell, styles.cellQuestion]}>{truncateText(item.question, 80)}</Text>
              {item.scores.map((score, idx) => (
                <View key={idx} style={[styles.cell, styles.cellScore]}>
                  {renderRectangle(score, idx, item.scores)}
                </View>
              ))}
            </View>
          ))}
      </View>
    <Footer/>
  </View>
);

export default HeartPage;

const data = [
  { id: 1, quadrant: "Heart", question: "When presented with a problem, I am most concerned with how the team is handling it.", scores: [1, 1, 1, 1] },
  { id: 2, quadrant: "Heart", question: "I ensure my decisions are measured by whether everyone is on board.", scores: [1, 1, 1, 1] },
  { id: 3, quadrant: "Heart", question: "I feel most fulfilled when I am surrounded by my people.", scores: [1, 1, 1, 1] },
  { id: 4, quadrant: "Heart", question: "I am motivated when I feel a sense of belonging.", scores: [1, 1, 1, 1] },
  { id: 5, quadrant: "Heart", question: "I rely heavily on passion when working on a project.", scores: [1, 1, 1, 0] },
  { id: 6, quadrant: "Heart", question: "I believe a collaborative team is the best way to achieve results.", scores: [1, 1, 1, 0] },
  { id: 7, quadrant: "Heart", question: "I want to feel connected to others when I am doing something.", scores: [1, 1, 1, 0] },
  { id: 8, quadrant: "Heart", question: "When working on a project, I can become too emotionally invested.", scores: [1, 1, 0, 0] },
  { id: 9, quadrant: "Heart", question: "My strong feelings sometimes overwhelm my good judgment.", scores: [1, 0, 0, 0] },
  { id: 10, quadrant: "Heart", question: "When I share a proposal, I want to know “who” is with me.", scores: [1, 0, 0, 0] },
  { id: 10, quadrant: "Heart", question: "When I share a proposal, I want to know “who” is with me.", scores: [1, 0, 0, 0] },
];
